// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"SZ-z","sponsoredTooltipWrapper":"TZ-z","sponsoredTooltip":"UZ-z","newCard":"VZ-z"};